<template>
  <div class="results" id="results-area">
    <div v-if="loading==='Not run'" class="mt-md-4 pt-3">
      {{hebrew ? 'הזן מילת חיפוש בשורת החיפוש' : 'Enter search phrase'}}.
    </div>
    <div>
      <div v-if="loading==='Complete'">
        <div v-if="searchResults.length==0 || searchResults[0] && searchResults[0].Error">
          <div id="no-results" v-if="searchResults.length==0" class="mt-md-4 pt-3">
            {{hebrew ? 'לא נמצאו תוצאות' : 'No results found'}}.
          </div>
          <small v-else class="d-block mt-4 mt-md-5 text-muted pt-md-5 text-center">
              <div v-if="hebrew">
                למילה זו יותר מדי היקרויות ב{{mode == 'tanach' ? 'תנ"ך' : 'תלמוד'}}, 
                ולכן אין אפשרות להציג תוצאות מה{{mode == 'tanach' ? 'תנ"ך' : 'תלמוד'}}.
              </div>   
              <div v-else>This phrase has too many instances in the {{mode == 'tanach' ? 'Tanach' : 'Talmud'}}, 
                therefore we are unable to display resutls.
              </div>
          </small>
        </div>
      </div>  
      <div v-if="searchResults[0] && !searchResults[0].Error">
         <div class="d-flex justify-content-between">          
          <div class="result-count">{{searchResults.length}} {{hebrew ? 'ביטויים' : 'Phrases'}}</div>
          <div><DisplayTabs @toggle-graph="setDisplay" :graphDisplay="showGraph"/></div>
        </div>              
        <div class="frame-area bg-white pt-1 mb-3 position-relative" v-if="searchResults.length > 0 && !searchResults[0].Error">
          <GraphDisplay v-if="showGraph" />
          <ResultList  v-if="!showGraph" :searchResults="searchResults" :currentPage="currentPageNumber" :perPage="10"/>        
        </div>
        <div class="d-none d-sm-block">
          <b-pagination
            v-if="searchResults.length > 10 && !showGraph"
            size="sm"
            limit="8"
            v-model="currentPageNumber"
            :total-rows="searchResults.length"
            :per-page="perPage"
            aria-controls="search-results"
            align="center"          
            first-text="לעמוד הראשון"
            prev-class="d-none"
            last-text="לעמוד האחרון"
            next-class="d-none"
            first-class="first-page"
            last-class="last-page"
            page-class="number"
          >
          </b-pagination>
        </div>
      </div>
    </div>
    <button 
      v-if="showBackToTop" 
      @click="scrollToTop" 
      id="scroll-to-top"
      class="btn btn-secondary position-fixed rounded">
      <i class="fa fa-chevron-up"></i>
    </button>
    <ServerFailedPopup v-if="showFailed" v-model="showFailed"/>
  </div>
</template>

<script>
  import ResultList from '@/components/ResultList'
  import ServerFailedPopup from '@/components/ServerFailedPopup'
  import DisplayTabs from '@/components/DisplayTabs'
  import GraphDisplay from '@/components/graph'
  import {RunStates} from '@/store/runStates'
  export default {
  name: 'Results',
  components: {ResultList, ServerFailedPopup, DisplayTabs, GraphDisplay},
  data() {
    return {
      perPage: 10,
      currentPageNumber: 1,
      showBackToTop: false,
      showGraph: false
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },  
  methods: {
    setDisplay (showGraph) {
      this.showGraph = showGraph
    },    
    handleScroll() {  
      this.showBackToTop = window.scrollY > 350
    },
    scrollToTop() {
      document.getElementById("app").scrollIntoView({ 
        behavior: 'smooth' 
      })
    }
  },
  computed: {
    hebrew () {      
      return this.$settings.hebrew
    },    
    searchWord () {
      return this.$store.state.textForApiCall  
    },
    searchResults () {
      return this.$store.state.searchApiResponse
    },
    loading: function () {
      return this.$store.state.searchApiState
    },
    mode () {
      return this.$store.state.mode
    },
    wordsNum () {
      return this.$store.state.wordsNum
    }, 
    showFailed: {
      get () {
        return this.$store.state.searchApiState === RunStates.TIMED_OUT || this.$store.state.searchApiState === RunStates.FAILED
      },
      set () {
        this.$store.commit('SEARCH_NOT_RUN')        
      }       
    }
  },
  watch: {
    searchResults () {
      this.currentPageNumber = 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .f-narkis {font-size: 20px;}
  #results-area.results {
    .result-count {
      line-height: 45px;
    }
    .frame-area{
      min-height: 400px;
      border-radius: 6px;
      box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);    
    }
    .page-link {
      color: black;
      background: none;
      border: none;      
    }
    .active {
      .page-link {
        text-decoration: underline;
        color: gray;
      }  
    }
    .first-page, .last-page {
      .page-link {
        border-radius: 2px;
        background-color: #e3e3e3;
      }
      &.disabled {
        display: none;
      }
    }
    button.position-fixed {
      bottom:12px;
      right:50px;
      @media (max-width: 991px)  {
        bottom: 62px;
        right: 15px;
      }  
    }
  }
  
</style>
